/**
 * 
 * @param {*} role 角色
 * @param {*} token 登录的token
 * @returns 
 */
 export function getLoginToken(role) {
  const token =  localStorage.getItem(`${role}LoginToken`);
  return token;
}
export function setLoginToken(role, token) {
  localStorage.setItem(`${role}LoginToken`, token);
}

/**
 * 访问地址存本地，方便token过期后，拦截器跳转到对应的入口
 * 
 */
export function setEntranceUrl(entrancePath) {
  localStorage.setItem('entrancePath', entrancePath);
}
export function getEntranceUrl(entrancePath) {
  return localStorage.getItem('entrancePath');
}

// 设置业务类型
export function setBusType(type) {
  localStorage.setItem('busType', type);
}
export function getBusType() {
  return localStorage.getItem('busType');
} 

